import React from "react";
import {
  Truck,
  Trash2,
  Hammer,
  Trees,
  Recycle,
  Building2,
  ArrowUpRight,
} from "lucide-react";
import { waLink } from "../lib/contact";

const SERVICES = [
  {
    icon: Truck,
    title: "Aluguel de Caçambas",
    desc: "Caçambas estacionárias para obras residenciais, comerciais e industriais em Jundiaí e toda região.",
    tag: "Mais pedido",
    msg: "Olá! Quero alugar uma caçamba. Pode me passar valores?",
  },
  {
    icon: Trash2,
    title: "Remoção de Entulho",
    desc: "Retirada rápida de resíduos da construção civil. Disk entulho com entrega e coleta no mesmo dia.",
    msg: "Olá! Preciso de remoção de entulho. Pode me ajudar?",
  },
  {
    icon: Hammer,
    title: "Caçambas para Reformas",
    desc: "Ideal para reformas de casas, apartamentos e comércios. Tamanhos compactos para áreas urbanas.",
    msg: "Olá! Estou em reforma e preciso de caçamba. Tem disponível?",
  },
  {
    icon: Trees,
    title: "Limpeza de Terrenos",
    desc: "Remoção de restos de obras, mato, poda e resíduos diversos. Terreno limpo e pronto pra obra.",
    msg: "Olá! Preciso fazer limpeza de terreno com caçamba.",
  },
  {
    icon: Recycle,
    title: "Descarte de Resíduos",
    desc: "Descarte correto e responsável conforme normas ambientais. Cuidamos do destino final do entulho.",
    msg: "Olá! Quero descartar resíduos de forma correta. Como funciona?",
  },
  {
    icon: Building2,
    title: "Atendimento Empresarial",
    desc: "Planos para empresas, condomínios e construtoras. Atendimento contínuo e nota fiscal.",
    tag: "Empresas",
    msg: "Olá! Sou de uma empresa/condomínio e quero atendimento contínuo.",
  },
];

export const Services = () => {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="relative py-16 md:py-24 bg-[#f4f4f5] border-y-2 border-[#0f172a]"
    >
      {/* hazard top stripe */}
      <div className="absolute top-0 left-0 right-0 h-2 hazard-stripes-thin" />
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <div className="inline-block px-3 py-1 bg-[#fff505] text-[#0f172a] text-xs font-extrabold uppercase tracking-[0.2em] mb-3 border-2 border-[#0f172a]">
              O que fazemos
            </div>
            <h2
              data-testid="services-title"
              className="font-display text-4xl sm:text-5xl md:text-6xl text-[#0f172a] max-w-3xl"
            >
              Nossos <span className="text-[#027ec3]">serviços</span> de caçamba e entulho
            </h2>
          </div>
          <p className="text-[#475569] font-medium md:max-w-sm">
            Solução completa para obras, reformas e remoções com entrega rápida
            em todos os bairros de Jundiaí.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map(({ icon: Icon, title, desc, tag, msg }, i) => (
            <a
              key={title}
              href={waLink(msg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`service-card-${i}`}
              className="group relative bg-white border-2 border-[#0f172a] p-6 md:p-7 shadow-brutal flex flex-col"
            >
              {tag && (
                <span className="absolute -top-3 right-5 bg-[#027ec3] text-white text-[10px] font-extrabold uppercase tracking-widest px-2.5 py-1 border-2 border-[#0f172a]">
                  {tag}
                </span>
              )}
              <div className="w-14 h-14 bg-[#fff505] border-2 border-[#0f172a] flex items-center justify-center mb-5">
                <Icon className="w-7 h-7 text-[#0f172a]" strokeWidth={2.5} />
              </div>
              <h3 className="font-display text-2xl md:text-[26px] text-[#0f172a] leading-tight">
                {title}
              </h3>
              <p className="mt-3 text-[#475569] font-medium leading-relaxed text-[15px] flex-1">
                {desc}
              </p>
              <div className="mt-5 inline-flex items-center gap-2 text-sm font-extrabold uppercase tracking-wider text-[#027ec3] group-hover:text-[#0f172a]">
                Solicitar pelo WhatsApp
                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={3} />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
